<template>
  <SpringPopup
    class="plaid-popup"
    :closable="true"
    :back-drop-closable="true"
    v-on="$listeners"
  >
    <div class="plaid-popup__logo">
      <img
        class="mx-auto text-2xl"
        :src="require('@/assets/img/nav/logo.svg')"
      >
    </div>

    <div class="plaid-popup-body">
      <h1 class="plaid-popup-body__header">
        Instant Verification Process
      </h1>
      <p class="text-left">
        For faster funding and enhanced offer accessibility, it is essential to connect your banking information via <span class="font-bold">Plaid</span>. Rest assured that your data is always kept secure.
        We do not store it and we ensure that it is encrypted and safely transferred.
      </p>

      <div class="plaid-popup-body__list">
        <div
          v-for="(item, index) in checkList"
          :key="index"
          class="plaid-popup-body__list-item"
        >
          <font-awesome-icon
            class="plaid-popup-body__list-icon"
            icon="check"
          />
          <p class="font-semibold">
            {{ item }}
          </p>
        </div>

        <AppButton
          class="mt-50 mb-40 sm:mt-80 w-full"
          @click="$emit('continue')"
        >
          Continue
        </AppButton>
      </div>
    </div>
  </SpringPopup>
</template>

<script>
import { SpringPopup } from 'spring-ui'
import AppButton from '@/components/common/buttons/AppButton'

export default {
  name: 'PlaidPopup',

  components: {
    SpringPopup,
    AppButton
  },

  data () {
    return {
      checkList: [
        'Verify your income',
        'Expedite your approval',
        'Get lower interest rates'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.plaid-popup {
  @apply flex px-20;

  &-body {
    @apply mx-auto xs-only:px-25 border-b-1;

    &__header {
      @apply my-30 font-display sm:text-2xl text-left font-semibold sm:text-center;

      @screen xs-only {
        font-size: 30px;
        line-height: 35px;
      }
    }

    &__list {
      @apply mt-30 sm:mt-60 flex flex-col mx-auto items-center justify-center;

      &-item {
        @apply flex my-10 w-300  ml-50;
      }

      &-icon {
        @apply text-purple-500 mr-20 font-bold;

        font-size: 20px;
      }
    }
  }

  &__logo {
    @apply mb-10 pb-30 border-b-1;
  }
}
</style>
